import { render, staticRenderFns } from "./SpecialistLocationServicesInfo.vue?vue&type=template&id=a8514324&scoped=true"
import script from "./SpecialistLocationServicesInfo.vue?vue&type=script&lang=js"
export * from "./SpecialistLocationServicesInfo.vue?vue&type=script&lang=js"
import style0 from "./SpecialistLocationServicesInfo.vue?vue&type=style&index=0&id=a8514324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8514324",
  null
  
)

export default component.exports